module.exports = __webpack_public_path__ + "static/media/D2-Abzeichen.4f8841dd.jpg";